/* RRW real stock (2026-10-03, owner: "inventory is off and it never can be off"). Every backend stock answer a page gets from
   api.roadrunnerwheels.com/api/* is corrected before the page reads it, for the SKUs in the hourly real-stock list (shop metafield
   rrw.vendor_stock, nightly-guard/vendor_stock_publish.py: suppliers whose backend stock is not kept current, plus every search row whose
   stock is over 3 days old -> the store's own number). The list comes from the page itself when it carries it (window.RRW_VENDOR_STOCK),
   otherwise from /pages/rrw-stock, fetched once and only when the page asks the backend for something. Ignored when over 3 days old.
   2026-10-04: also one card per Hardrock / DRW / Curva / Diablo / Gianna wheel (rrwDwgMerge below; names in assets/rrw-dwg-names.js). */
(function () {
  if (window.__rrwRealStock || !window.fetch) return;
  window.__rrwRealStock = 1;
  var of = window.fetch, map = null, loading = null;
  var ME = (document.currentScript && document.currentScript.src) || '', names = null, nloading = null;
  var NAMES_V = '20261005011904';   // set by build_names.py on every rebuild of assets/rrw-dwg-names.js
  function fresh(vs) { return !!(vs && vs.qty && (!vs.updated || Date.now() - Date.parse(vs.updated) < 3 * 86400000)); }
  function getMap() {
    if (map) return Promise.resolve(map);
    if (fresh(window.RRW_VENDOR_STOCK)) return Promise.resolve(map = window.RRW_VENDOR_STOCK);
    return loading || (loading = of.call(window, '/pages/rrw-stock', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { map = fresh(j) ? j : { qty: {} }; return map; })
      .catch(function () { map = { qty: {} }; return map; }));
  }
  function fix(row, q) {
    var qd = row.qty_display, had = Number(qd.total_sellable != null ? qd.total_sellable : qd.total) || 0;
    q = Math.max(0, Number(q) || 0);
    if (had === q && qd.qty_known !== false) return false;
    ['local', 'regional', 'nationwide', 'local_plus', 'store_on_hand', 'same_day_available'].forEach(function (k) { if (qd[k] != null) qd[k] = Math.min(Number(qd[k]) || 0, q); });
    if (q > had) qd.nationwide = (Number(qd.nationwide) || 0) + (q - had);
    qd.total = qd.total_sellable = q; qd.qty_known = true; qd.label = q > 0 ? 'Ships from warehouse: ' + q : 'Out of stock';
    ['qty_local', 'qty_local_plus', 'quantity_on_hand'].forEach(function (k) { if (row[k] != null) row[k] = Math.min(Number(row[k]) || 0, q); });
    if (row.qty_nationwide != null) row.qty_nationwide = Number(qd.nationwide) || 0;
    if (q <= 0 && row.install_timing) row.install_timing.tier = 'out_of_stock';
    return true;
  }
  function walk(o, d, qty) {
    if (!o || typeof o !== 'object' || d > 9) return false;
    var ch = false, i;
    if (Array.isArray(o)) { for (i = 0; i < o.length; i++) ch = walk(o[i], d + 1, qty) || ch; return ch; }
    if (o.sku && o.qty_display && typeof o.qty_display === 'object' && qty[o.sku] != null) ch = fix(o, qty[o.sku]) || ch;
    for (var k in o) if (o[k] && typeof o[k] === 'object') ch = walk(o[k], d + 1, qty) || ch;
    return ch;
  }
  /* DWG / WD Atlanta merge (2026-10-04, owner: "you duplicated some wheel listings again" / "from dwg"). The backend carries the same
     Hardrock / DRW / Curva wheel twice: the WD Atlanta row ("HR713", "GLOSS BLACK") and the Dynamic Wheel Group row ("H713 Horseshoe",
     "Gloss Black") -> two cards for one wheel. Each row of these brands is named exactly like the store listing that sells its SKU
     (RRW_DWG_NAMES = {n:[[model, finish]], s:{sku: n-index}, c:{"brand|CODE": [n-index]}}, built from the store titles), and when both
     suppliers carry the same size only one row stays: the one linked to the store variant (owner 10-03: the store sells both suppliers'
     stock on the WD item number at DWG MAP), else the DWG row, else the one with more stock; a kept row without a store link takes the other's. */
  function rrwDwgMerge(arr, D) {
    if (!Array.isArray(arr) || !D || !D.n) return false;
    var BR = ['hardrock', 'curva', 'drw', 'diablo', 'gianna'];
    function bk(b) { b = String(b || '').toLowerCase(); for (var i = 0; i < BR.length; i++) if (b.indexOf(BR[i]) === 0) return BR[i]; return ''; }
    function code(b, m) {
      m = String(m || '').toUpperCase().trim(); var x;
      if (b === 'hardrock' && (x = m.match(/^H[RC]?(\d{3})/))) return 'H' + x[1];
      if (b === 'drw' && (x = m.match(/^DR?(\d{2})/))) return 'D' + x[1];
      return m.split(/\s+/)[0];
    }
    function nf(f) { return String(f || '').toLowerCase().replace(/-?\s*black\s*b\/l|\bb\/l\b/g, '').replace(/machine face/g, 'machined face').replace(/gun metal/g, 'gunmetal').replace(/[^a-z]+/g, ' ').trim(); }
    function tc(s) { return String(s || '').toLowerCase().replace(/(^|\s)[a-z]/g, function (c) { return c.toUpperCase(); }); }
    var changed = false, i, r;
    for (i = 0; i < arr.length; i++) {
      r = arr[i]; if (!r || !r.sku || typeof r !== 'object') continue;
      var b = bk(r.brand); if (!b) continue;
      var j = D.s[r.sku], p = j != null ? D.n[j] : null;
      if (!p) {
        var c = D.c[b + '|' + code(b, r.model)] || [], want = nf(r.finish), hit = [];
        for (var k = 0; k < c.length; k++) if (nf(D.n[c[k]][1]) === want) hit.push(c[k]);
        if (hit.length === 1) p = D.n[hit[0]];
        else if (c.length) p = [D.n[c[0]][0], tc(String(r.finish || '').replace(/-?\s*black\s*b\/l/i, '').trim())];
      }
      if (p && (r.model !== p[0] || r.finish !== p[1])) { r.model = p[0]; r.finish = p[1]; changed = true; }
    }
    var seen = {}, out = [], L = ['shopify_product_id', 'shopify_variant_id', 'shopify_handle'];
    function qty(x) { var q = x.qty_display || {}; return Number(q.total_sellable != null ? q.total_sellable : q.total) || 0; }
    function take(to, from) { if (!to.shopify_variant_id && from.shopify_variant_id) L.forEach(function (f) { to[f] = from[f]; }); }
    for (i = 0; i < arr.length; i++) {
      r = arr[i];
      var b2 = r && r.sku ? bk(r.brand) : '';
      if (!b2) { out.push(r); continue; }
      var key = [b2, r.model, r.finish, r.diameter_in, r.width_in, r.offset_mm, (r.bolt_patterns_canonical || []).slice().sort().join(',')].join('|');
      var s = seen[key];
      if (s == null) { seen[key] = out.length; out.push(r); continue; }
      var prev = out[s]; changed = true;
      // keep the row the store sells (it carries the store link + both suppliers' stock, owner 10-03 "use both stocks"), else DWG, else more stock
      var rank = function (x) { return (x.shopify_variant_id ? 4 : 0) + (x.source_guide === 'DWG' ? 2 : 0); };
      var better = rank(r) > rank(prev) || (rank(r) === rank(prev) && qty(r) > qty(prev));
      if (better) { take(r, prev); out[s] = r; } else take(prev, r);
    }
    if (out.length !== arr.length) { arr.length = 0; Array.prototype.push.apply(arr, out); }
    return changed;
  }
  var DWG_RE = /^(hardrock|curva|drw|diablo|gianna)/i;
  function dwgArrays(o, d, out) {   // arrays of wheel rows that contain one of these brands
    if (!o || typeof o !== 'object' || d > 6) return out;
    if (Array.isArray(o)) {
      if (o.length && o[0] && typeof o[0] === 'object' && o[0].sku && 'brand' in o[0]) { for (var i = 0; i < o.length; i++) if (o[i] && (DWG_RE.test(o[i].brand || '') || /^(more colors|custom|ps|gb|gm|bs|sm)$/i.test(o[i].finish || ''))) { out.push(o); break; }
        if (out.indexOf(o) < 0) caseOnly.push(o); return out; }
      for (var j = 0; j < o.length; j++) dwgArrays(o[j], d + 1, out); return out;
    }
    for (var k in o) if (o[k] && typeof o[k] === 'object') dwgArrays(o[k], d + 1, out);
    return out;
  }
  var caseOnly = [];
  // 2026-10-05: the same wheel with one finish written two ways ("GLOSS BLACK" / "Gloss Black", KG1 feed) made two cards -> one spelling per brand+model
  function oneSpelling(arr) {
    var pref = {}, ch = false, i, w, k;
    for (i = 0; i < arr.length; i++) { w = arr[i]; if (!w || !w.finish || !w.brand) continue; k = w.brand + '|' + w.model + '|' + String(w.finish).toLowerCase();
      if (!pref[k] || (pref[k] === pref[k].toUpperCase() && w.finish !== w.finish.toUpperCase())) pref[k] = w.finish; }
    for (i = 0; i < arr.length; i++) { w = arr[i]; if (!w || !w.finish || !w.brand) continue; k = pref[w.brand + '|' + w.model + '|' + String(w.finish).toLowerCase()];
      if (k && k !== w.finish) { w.finish = k; ch = true; } }
    return ch;
  }
  function getNames() {   // assets/rrw-dwg-names.js (same folder as this file) sets window.RRW_DWG_NAMES; loaded only when a DWG-brand row shows up
    if (names) return Promise.resolve(names);
    if (window.RRW_DWG_NAMES) return Promise.resolve(names = window.RRW_DWG_NAMES);
    if (!ME) return Promise.resolve(null);
    return nloading || (nloading = new Promise(function (res) {
      var s = document.createElement('script'); s.async = true;
      s.src = ME.replace(/rrw-real-stock\.js[^/]*$/, 'rrw-dwg-names.js') + '?v=' + NAMES_V;   // versioned: the CDN caches an asset URL for a year
      s.onload = function () { res(names = window.RRW_DWG_NAMES || null); };
      s.onerror = function () { res(null); };
      document.head.appendChild(s);
    }));
  }
  window.fetch = function (input) {
    var u = typeof input === 'string' ? input : (input && input.url) || '', p = of.apply(this, arguments);
    if (!/^https:\/\/api\.roadrunnerwheels\.com\/api\//.test(u) || /\/api\/img\b/.test(u)) return p;
    return Promise.all([p, getMap()]).then(function (a) {
      var r = a[0], vs = a[1];
      if (!r || !r.ok || (r.headers.get('content-type') || '').indexOf('json') < 0) return r;
      return r.clone().json().then(function (j) {
        caseOnly = [];
        var ch = !!(vs && vs.qty) && walk(j, 0, vs.qty), arrs = dwgArrays(j, 0, []), co = caseOnly.slice();
        for (var ci = 0; ci < co.length; ci++) ch = oneSpelling(co[ci]) || ch;
        return (arrs.length ? getNames() : Promise.resolve(null)).then(function (D) {
          if (D) for (var i = 0; i < arrs.length; i++) {
            // 2026-10-05: distributor placeholder finish "More Colors" -> the maker's finish from the store listing selling that SKU (search for "bronze" finds it)
            if (D.f) {
              var byModel = {}, fi, w;
              for (fi = 0; fi < arrs[i].length; fi++) { w = arrs[i][fi]; if (w && /^(more colors|custom)$/i.test(w.finish || '') && D.f[w.sku]) { w.finish = D.f[w.sku]; byModel[w.brand + '|' + w.model] = w.finish; ch = true; } }
              // same brand + model code (the code carries the finish, e.g. 607BZ) for sizes that are not on the store
              for (fi = 0; fi < arrs[i].length; fi++) {   // KG1 feed sends finish codes (PS, GB ...) for some parts
                w = arrs[i][fi]; var kc = w && D.k && D.k[w.brand] && D.k[w.brand][String(w.finish || '').toUpperCase()];
                if (kc) { w.finish = kc; ch = true; }
              }
              for (fi = 0; fi < arrs[i].length; fi++) {   // 2026-10-05: treatment-only names ("Milled") on black/silver milled parts -> maker's name by model code
                w = arrs[i][fi]; var xm = w && D.x && D.x[w.brand], xf = xm && xm[String(w.model || '').trim().split(/\s+/)[0].toUpperCase() + '|' + String(w.finish || '').trim().toUpperCase()];
                if (xf) { w.finish = xf; ch = true; }
              }
              for (fi = 0; fi < arrs[i].length; fi++) {
                w = arrs[i][fi]; if (!w || !/^(more colors|custom)$/i.test(w.finish || '')) continue;
                var mf = byModel[w.brand + '|' + w.model] || (D.m && D.m[w.brand + '|' + w.model]);   // store listing of the same brand + model code
                if (mf) { w.finish = mf; ch = true; }
              }
            }
            ch = oneSpelling(arrs[i]) || ch;
            ch = rrwDwgMerge(arrs[i], D) || ch;   // stock first, then one card per wheel
          }
          if (!ch) return r;
          var nr = new Response(JSON.stringify(j), { status: r.status, statusText: r.statusText, headers: { 'Content-Type': 'application/json' } });
          try { Object.defineProperty(nr, 'url', { value: r.url }); } catch (e) {}   // pages read response.url (the vehicle page's store-row merge needs it)
          return nr;
        });
      }).catch(function () { return r; });
    }, function () { return p; });
  };
})();
